// extracted by mini-css-extract-plugin
export default {"addItem":"ItemForm_addItem__xt40G","label":"ItemForm_label__BUaED","nameLabel":"ItemForm_nameLabel__OOzOa","previewImage":"ItemForm_previewImage__Xqs2d"};